@if (!hasFile()) {
  <div class="file-upload">
    <button mat-button (click)="fileUpload.click()">
      <mat-icon>{{ chooseIconValue() }}</mat-icon>
      @if (chooseFileTextValue()) {
        <span> {{ chooseFileTextValue() }} </span>
      } @else {
        <span>{{ 'file-upload.choose-file' | translate }}</span>
      }
    </button>
  </div>
} @else {
  <div class="file-upload">
    <ng-template
      [ngTemplateOutlet]="errorTemplate || defaultErrorTemplate"
      [ngTemplateOutletContext]="{ errors: controlErrors() }"
    >
    </ng-template>
    <ng-template
      [ngTemplateOutlet]="previewTemplate || defaultPreviewTemplate"
      [ngTemplateOutletContext]="{ file: fileForObjectUrl() }"
    ></ng-template>
    <div class="file-upload__actions">
      @if (rechooseEnabledValue()) {
        <button mat-button (click)="fileUpload.click()" data-test="file-upload__rechoose-button">
          <mat-icon>{{ rechooseIconValue() }}</mat-icon>
          @if (chooseOtherFileTextValue()) {
            {{ chooseOtherFileTextValue() }}
          } @else {
            {{ 'file-upload.choose-other' | translate }}
          }
        </button>
      }
      @if (resetEnabledValue()) {
        <button mat-button (click)="reset()" data-test="file-upload__reset-button">
          <mat-icon>{{ resetIconValue() }}</mat-icon>
          @if (resetTextValue()) {
            {{ resetTextValue() }}
          } @else {
            {{ 'file-upload.reset' | translate }}
          }
        </button>
      }
      @if (downloadEnabledValue()) {
        <button mat-button (click)="downloadLink.click()" data-test="file-upload__download-button">
          <mat-icon>{{ downloadIconValue() }}</mat-icon>
          @if (downloadTextValue()) {
            {{ downloadTextValue() }}
          } @else {
            {{ 'file-upload.download' | translate }}
          }
        </button>
      }
    </div>
  </div>
  <a #downloadLink hidden [href]="fileForObjectUrl() | objectUrl" download>Download</a>
}

<input
  #fileUpload
  hidden
  type="file"
  [accept]="allowedMimeTypes | join: ', '"
  (change)="onFileUploadChange(fileUpload)"
/>

<ng-template #defaultPreviewTemplate let-file="file">
  <div class="file-upload__preview-wrapper">
    <img
      [src]="file | objectUrl"
      [alt]="'file-upload.uploaded-image' | translate"
      class="file-upload__preview"
    />
  </div>
  <mat-divider></mat-divider>
</ng-template>

<ng-template #defaultErrorTemplate let-errors="errors">
  @if (errors?.maxFileSize) {
    <div
      class="notification notification-error text--input-small"
      data-test="file-upload__error-max-file-size"
    >
      <mat-icon>error</mat-icon>
      {{
        'file-upload.max-file-size-error'
          | translate: { maxSize: maxFileSizeValue() | agrHumanFileSize }
      }}
    </div>
  }
</ng-template>
